import {useState} from 'react'
import { sendEmailWriteUs } from "../../../Api";
import { AlertDialog } from '../../../components/Dialog/Dialog';

const Footer = ({formatRut}) => {

    const [data, setData] = useState({
        nombre: '',
        mensaje: '',
        email: '',
        rut: '',
        telefono: ''
    });
    const [alertMessage, setAlertMessage] = useState();
    const [showAlertError, setShowAlertError] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleChange = event => {
        let name = event.target.name;
        let value = event.target.value;
        if(name === 'rut'){
            value = formatRut(value);
        }
        setData({...data, [name]: value })
    }

    const sendMail = async () => {
        if(data.nombre === '' || data.mensaje === '' || data.email === '' || data.rut === '' || data.telefono === ''){
            alert('Todos los campos son requeridos');
            return;
        }

        const _response = await sendEmailWriteUs(data);
        if (_response.status) {
            setSuccess(true);
            setData({
                nombre: '',
                mensaje: '',
                email: '',
                rut: '',
                telefono: ''
            });
        } else {
            setSuccess(false);
        }
        alert(_response.message);
    };

    const alert = message => {
        setAlertMessage(message);
        setShowAlertError(true);
    }

    return (
        <>
        <footer>
            <div className="container-contact container-fluid" id="container-contact">
                <div className="row" id="contacto">
                    <div className="col-md-6 datos-contacto">
                        <h3 className="title-contactenos text-white">Contáctenos</h3>
                        <p className="desc-footer">
                            <a href="mailto:informaciones@amsm.cl" className="phone">informaciones@amsm.cl</a>
                            <br /><br />
                            Antonia López de Bello Nº 0412, <br /> Providencia, Santiago, Chile
                            <br /><br />
                            Horario: Lunes a Jueves 08:30 a 17:00
                            <br></br>
                            Viernes 08:30 a 15:30
                            <br></br>
                            <a href="tel:+56 2 2913 3243" className="phone">Fono: +56 2 2913 3243</a>
                        </p>
                    </div>
                    <div className="col-md-6">
                        <h5 className="title-escribenos">
                            Escribenos
                        </h5>

                        <form className="form-horizontal form-contacto" id="form-contacto" method="POST"
                            action="https://noticias.amsm.cl/contacto">

                            <div className="row">
                                <div className="col-md-6">
                                    <input 
                                        type="text" 
                                        className="form-control nombre" 
                                        name="nombre" 
                                        value={data.nombre}
                                        placeholder="Nombre" 
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <input 
                                        type="text" 
                                        className="form-control rut" 
                                        name="rut"
                                        value={data.rut} 
                                        placeholder="RUT*"
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-md-6">
                                    <input 
                                        type="email" 
                                        className="form-control email" 
                                        id="email" 
                                        name="email" 
                                        value={data.email}
                                        placeholder="Email" 
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <div className="input-group mb-3">
                                        <input 
                                            type="text" 
                                            className="form-control telefono" 
                                            id="telefono" 
                                            name="telefono"
                                            value={data.telefono} 
                                            placeholder="Teléfono" 
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-md-12">
                                    <textarea 
                                        name="mensaje" 
                                        className="form-control mensaje" 
                                        id="mensaje" 
                                        cols="10" 
                                        rows="7"
                                        style={{height: '180px'}}
                                        placeholder="Mensaje"
                                        onChange={handleChange}
                                        value={data.mensaje}
                                    ></textarea>
                                </div>
                            </div>
                            <br /><br />
                            <div className="form-group group-enviar">
                                <button 
                                    type="button"
                                    className="btn btn-primary btn-login-mail" 
                                    onClick={() => sendMail()}>
                                    ENVIAR
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
            <div className="footer-credits">
                <span className="copyright">{new Date().getFullYear().toString()} © AMSM. Todos los derechos reservados. v1.1.7</span>
                <a href='https://gux.tech/'>
                    <span className="copyright">Desarrollado por GUX</span>
                </a>
            </div>
        </footer>
        <AlertDialog
            message={alertMessage}
            show={showAlertError}
            success={success}
            onConfirm={() => {
                setShowAlertError(false);
            }}
        />
        </>
    )
}

export default Footer